import { mappedEventStatusType } from '@src/common/constant/enum';
import { IBlockVideoEventData, TBlockEventsPostData } from '@src/common/types/empTypes';

import instance from '../common';
import { WorkbenchDeployInfo } from '@src/typings/workbench';

// get query dimensian data /v1/event_categories
function getDimensionData(params: { src: 'trends' | 'emp' } = { src: 'emp' }, queryBody) {
  return instance.post(`/v1/query?src=${params.src}`, queryBody);
}

function getEventCategory() {
  return instance.get(`/v1/event_categories`);
}

interface IGetMappedEvents {
  status?: mappedEventStatusType;
  need_detail?: boolean;
  need_out_of_box?: number;
  preferred_version?: 'deployed' | 'draft';
  need_bad_event?: number; // If the need_bad_event=1, EMP will add Bad Event in the response, otherwise, EMP will filter it in response.
  need_all_storage?: number; // 1 is all storage predefined mapped event except Bad Event, 0 is default
}

function getMappedEvents(params?: IGetMappedEvents) {
  return instance.get(`/v1/mapped_events`, { params });
}

function postMappedEvents(queryBody) {
  return instance.post(`/v1/mapped_events`, queryBody);
}

function getMappedEventById(id: string) {
  return instance.get(`/v1/mapped_event/${id}`);
}

function updateMappedEvent(id: string, queryBody) {
  return instance.put(`/v1/mapped_event/${id}`, queryBody);
}

function deleteMappedEvent(id: number | string) {
  return instance.delete(`/v1/mapped_event/${id}`);
}

function postQuickMap(queryBody) {
  return instance.post(`/v1/mapped_event/quick_map`, queryBody);
}

function updatePreset(id: string, queryBody: any) {
  return instance.put(`/v1/preset/${id}`, queryBody);
}

function getMappedEventMetadataEventName() {
  return instance.get(`/v1/mapped_event/metadata_event_name`);
}

function getMappedStatusEvent(field: 'event_name' | 'tag_key' | 'tag_value') {
  return instance.get(`/v1/mapped_event/metadata?field=${field}`);
}

function getPresets() {
  return instance.get('/v1/presets');
}

function getDeployCandidateList() {
  return instance.get('/v1/deploy_list');
}

function getWorkbenchDeployInfo() {
  return instance.get<{
    data: WorkbenchDeployInfo;
  }>('/v1/workbench/deploy/job');
}

function postWorkbenchDeploy(payload) {
  return instance.post('/v1/workbench/deploy', payload);
}

function exportWorkbenchToProduction(payload) {
  return instance.post('/v1/export', payload);
}
/*
 * resources: 'mapped_events' | 'metrics' | 'custom_dimension' | 'flow'
 */
function postDeployList(resource: string, payload: { ids: number[] }) {
  return instance.post(`/v1/deploy_list/${resource}`, payload);
}

function postDeploy(queryBody) {
  return instance.post('/v1/deploy', queryBody);
}

function postBlockEvents(events: TBlockEventsPostData[]) {
  return instance.post(`/v1/block_events`, { events });
}

function postBlockVideoEvents(events: IBlockVideoEventData[]) {
  return instance.post(`/v1/block_video_events`, { events });
}

function getBlockVideoEvents() {
  return instance.get(`/v1/block_video_events`);
}

function getBlockEventById(id: string) {
  return instance.get(`/v1/block_events/${id}`);
}

function getBlockEvents(event?: string) {
  let url = `/v1/block_events`;
  if (event) {
    url = `/v1/block_events?event_name=${event}`;
  }
  return instance.get(url);
}

function postUnblockEvents(events: string[]) {
  return instance.post(`/v1/unblock`, { events });
}

function postUnblockVideoEvents(events: string[]) {
  return instance.post(`/v1/unblock_video`, { events });
}

// get all data transform names.
function getAllDataTransform(targetDimension: string) {
  return instance.get(`/v1/data_transform?dimension=${targetDimension}`);
}

// create a data transform name to the target dimension
function postDataTransform(queryBody) {
  return instance.post(`/v1/data_transform`, queryBody);
}

// get data transform by name id
function getDataTransformByNameId(name_id: number) {
  return instance.get(`/v1/data_transform/${name_id}`);
}

// update data transform name by name id
function updateDataTransform(name_id: number, queryBody) {
  return instance.put(`/v1/data_transform/${name_id}`, queryBody);
}

// delete a data transform name by id
function deleteDateTransform(name_id: number) {
  return instance.delete(`/v1/data_transform/${name_id}`);
}

// get all mapped events
function getMappedEventManagementList() {
  return instance.get(`/v1/management/mapped_events`);
}

// get details of a single event
function getMappedEventDetail(event_id: number, version_id: number) {
  return instance.get(`/v1/mapped_event/${event_id}/${version_id}`);
}

function getNetworkConfigures() {
  return instance.get(`/v1/network_request/configuration`);
}

function postNetworkConfigures(queryBody: any) {
  return instance.post(`/v1/network_request/configuration`, queryBody);
}

function updateNetworkConfigures(id: string, queryBody: any) {
  return instance.put(`/v1/network_request/configuration/${id}`, queryBody);
}

function deleteNetworkConfigures(id: string) {
  return instance.delete(`/v1/network_request/configuration/${id}`);
}

function reorderNetworkConfigures(orderedIds: string[]) {
  return instance.put(`/v1/network_request/configuration/reorder`, { order: orderedIds });
}

function getClickTrackingData() {
  return instance.get(`/v1/clickcc/configuration`);
}
function postClickTracking(queryBody: any) {
  return instance.post(`/v1/clickcc/configuration`, queryBody);
}
function getSessionReplayData() {
  return instance.get(`/v1/remote-config/session-replay`);
}

function postSessionReplay(queryBody: any) {
  return instance.post(`/v1/remote-config/session-replay`, queryBody);
}

function deleteCollectAttr(queryBody: any) {
  return instance.delete(`/v1/clickcc/collectattr`, {
    data: queryBody,
  });
}

function getDeployTasks(params: { page: number; limit: number }) {
  return instance.get(`/v1/deploy_tasks`, { params });
}
/**
 *
 [DELETE] /v1/mapped_event/{event_id}
 [GET] /v1/mapped_event/metadata_event_name
 */
export {
  getDimensionData,
  getMappedEventById,
  postMappedEvents,
  getMappedEvents,
  getEventCategory,
  updateMappedEvent,
  getMappedEventMetadataEventName,
  getMappedStatusEvent,
  deleteMappedEvent,
  postQuickMap,
  updatePreset,
  getPresets,
  getDeployCandidateList,
  postDeployList,
  postDeploy,
  postBlockEvents,
  postBlockVideoEvents,
  getBlockEventById,
  getBlockEvents,
  getBlockVideoEvents,
  getAllDataTransform,
  postDataTransform,
  getDataTransformByNameId,
  updateDataTransform,
  deleteDateTransform,
  postUnblockEvents,
  postUnblockVideoEvents,
  getMappedEventManagementList,
  getMappedEventDetail,
  getNetworkConfigures,
  postNetworkConfigures,
  updateNetworkConfigures,
  deleteNetworkConfigures,
  reorderNetworkConfigures,
  getClickTrackingData,
  getSessionReplayData,
  postSessionReplay,
  postClickTracking,
  deleteCollectAttr,
  getWorkbenchDeployInfo,
  postWorkbenchDeploy,
  exportWorkbenchToProduction,
  getDeployTasks,
};
export type { IGetMappedEvents };
